"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OGtagsAEM = exports.OGtags = exports.Title = exports.Meta = exports.Script = exports.Link = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactHelmetAsync = require("react-helmet-async");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// TODO improve type
// @ts-ignore
_reactHelmetAsync.Helmet.defaultProps.defer = false;

var Link = function Link(props) {
  var children = props.children,
      tagProps = _objectWithoutProperties(props, ["children"]);

  return /*#__PURE__*/_react.default.createElement(_reactHelmetAsync.Helmet, null, /*#__PURE__*/_react.default.createElement("link", tagProps, children));
};

exports.Link = Link;

var Script = function Script(props) {
  var children = props.children,
      tagProps = _objectWithoutProperties(props, ["children"]);

  return /*#__PURE__*/_react.default.createElement(_reactHelmetAsync.Helmet, null, /*#__PURE__*/_react.default.createElement("script", tagProps, children));
};

exports.Script = Script;

var Meta = function Meta(props) {
  var children = props.children,
      tagProps = _objectWithoutProperties(props, ["children"]);

  return /*#__PURE__*/_react.default.createElement(_reactHelmetAsync.Helmet, null, /*#__PURE__*/_react.default.createElement("meta", tagProps, children));
};

exports.Meta = Meta;

var Title = function Title(props) {
  var children = props.children,
      tagProps = _objectWithoutProperties(props, ["children"]);

  return /*#__PURE__*/_react.default.createElement(_reactHelmetAsync.Helmet, null, /*#__PURE__*/_react.default.createElement("title", tagProps, children));
};

exports.Title = Title;

var OGtags = function OGtags(_ref) {
  var title = _ref.title,
      description = _ref.description,
      url = _ref.url,
      image = _ref.image,
      type = _ref.type;
  return /*#__PURE__*/_react.default.createElement(_reactHelmetAsync.Helmet, null, /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:type",
    content: type
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:site_name",
    content: "David's Bridal"
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:url",
    content: url
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:title",
    content: title
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:description",
    content: description
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:image",
    content: image
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "twitter:card",
    content: "summary"
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "twitter:site",
    content: "@davidsbridal"
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "twitter:creator",
    content: "@davidsbridal"
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "twitter:title",
    content: title
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "twitter:description",
    content: description
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "twitter:image",
    content: image
  }), /*#__PURE__*/_react.default.createElement("link", {
    rel: "canonical",
    href: "/".concat(url)
  }));
};

exports.OGtags = OGtags;

var OGtagsAEM = function OGtagsAEM(_ref2) {
  var title = _ref2.title,
      description = _ref2.description,
      url = _ref2.url,
      image = _ref2.image,
      type = _ref2.type;
  return /*#__PURE__*/_react.default.createElement(_reactHelmetAsync.Helmet, null, description && /*#__PURE__*/_react.default.createElement("meta", {
    name: "description",
    content: description
  }), description && /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:description",
    content: description
  }), url && /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:url",
    content: url
  }), title && /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:title",
    content: title
  }), image && /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:image",
    content: image
  }), type && /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:type",
    content: type
  }), /*#__PURE__*/_react.default.createElement("link", {
    rel: "canonical",
    href: "".concat(window.location.origin).concat(window.location.pathname)
  }));
};

exports.OGtagsAEM = OGtagsAEM;